module.exports = __webpack_public_path__ + "static/media/logoWebgerente.2ace71bc.svg";